import React, { Component } from "react";
import {
  Table,
  Typography,
  TableBody,
  TableRow,
  TableCell,
  Link,
  TableHead,
} from "@material-ui/core";
import PeopleIcon from "@material-ui/icons/People";
import { withStyles } from "@material-ui/styles";

const CityDetailsTable = withStyles({
  root: {},
})(Table);

const HeadingTypography = withStyles({
  root: {},
})(Typography);

const HeadingLink = withStyles({
  root: {},
})(Link);

const PlaceDetailTypography = withStyles({
  root: {
    color: "#8091af",
  },
})(Typography);

const TableCellYear = withStyles({
  root: {},
})(TableCell);

class MarkerInfoWindow extends Component {
  //dont know why setState doesnt work
  //we will probably use props to display city information

  render() {
    const cityObject = this.props.city;
    return (
      <React.Fragment>
        {this.renderCityDetails(cityObject)}
        {this.renderCityYearsTable(cityObject)}
      </React.Fragment>
    );
  }

  renderCityDetails = (cityObject) => {
    return (
      <div
        style={{
          paddingLeft: "15px",
        }}
      >
        <HeadingTypography variant="h5">
          {cityObject.city_name}
        </HeadingTypography>
      </div>
    );
  };

  renderPopulationDetail(cityObject) {
    if (cityObject.provider !== "město") {
      return (
        <React.Fragment>
          <PeopleIcon style={{ paddingRight: "8px" }} />
          <PlaceDetailTypography variant="button">
            {cityObject.inhabitants_count}
          </PlaceDetailTypography>
        </React.Fragment>
      );
    }
  }
  renderCityYearsTable = (cityObject) => {
    cityObject.yearsArray.sort(this.compareYears);
    return (
      <CityDetailsTable size="small">
        <TableHead>
          <TableRow>
            <TableCell align="left">ročník</TableCell>
            <TableCell align="left">počet hlasujících</TableCell>
            <TableCell align="left">rozpočet</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {cityObject.yearsArray.map((yearObject) => (
            <TableRow>
              <TableCell align="left">{this.renderLink(yearObject)}</TableCell>
              <TableCell align="left">
                {this.formatNumber(yearObject.voters_count)}
              </TableCell>
              <TableCell align="left">
                {this.formatNumber(yearObject.budget) + " Kč"}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </CityDetailsTable>
    );
  };

  compareYears(yearObject1, yearObject2) {
    return yearObject2.year - yearObject1.year;
  }

  formatNumber(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  }

  renderLink(yearObject) {
    if (yearObject.link === "") {
      return yearObject.year;
    } else {
      return <Link href={yearObject.link}>{yearObject.year}</Link>;
    }
  }
}

export default MarkerInfoWindow;
